import apiClient from './api';

// API URL 가져오기
const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000';

export const assetManagementService = {
  // 회사명으로 자동 검색 (웹 크롤링)
  findReport(companyName) {
    const formData = new FormData();
    formData.append('company_name', companyName);

    return apiClient.post('/evaluate/find-report', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 7200000, // 타임아웃
    });
  },

  // 회사명으로 자동 검색 (SSE 스트리밍)
  findReportStream(companyName, onProgress, onComplete, onError) {
    const formData = new FormData();
    formData.append('company_name', companyName);

    // fetch를 사용하여 SSE 연결
    fetch(`${API_BASE_URL}/evaluate/find-report-stream`, {
      method: 'POST',
      body: formData,
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let isReading = true;

        while (isReading) {
          const { done, value } = await reader.read();
          if (done) {
            isReading = false;
            break;
          }

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n\n');
          buffer = lines.pop() || '';

          for (const line of lines) {
            if (line.startsWith('data: ')) {
              try {
                const data = JSON.parse(line.slice(6));
                
                if (data.type === 'progress') {
                  onProgress(data);
                } else if (data.type === 'complete') {
                  onComplete(data.data);
                } else if (data.type === 'error') {
                  onError(data);
                }
              } catch (e) {
                console.error('SSE 파싱 오류:', e);
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error('SSE 연결 오류:', error);
        onError({ message: error.message });
      });
  },

  // 파일 직접 업로드
  uploadReports(companyName, files) {
    const formData = new FormData();
    formData.append('company_name', companyName);

    files.forEach((file) => {
      formData.append('files', file);
    });

    return apiClient.post('/evaluate/upload-report', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 7200000, // 타임아웃
    });
  },
};
